
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Loader, UnsubscriberClass, SortedFilteredList } from '@aston/foundation';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { CompletedAccountingListSortProp} from '../../enums';
import { ICompletedAccountingListItem, IImportItem} from '../../models';


@Component({
	selector: 'import-documents-completed-synthesis-report',
	templateUrl: './import-documents-completed-synthesis-report.component.html',
	imports: [TranslateModule]
})
export class ImportDocumentsCompletedSynthesisReportComponent extends UnsubscriberClass {
	@Input() currentImport: IImportItem;
	@Input() currentImportLoader = Loader.empty();
	@Input() completedAccountingList$: Observable<SortedFilteredList<Partial<ICompletedAccountingListItem>, CompletedAccountingListSortProp>>;
	@Input() completedAccountingListLoader = Loader.empty();
	@Input() showDismiss: boolean;

	@Output() dismiss = new EventEmitter<void>();
	@Output() download = new EventEmitter<void>();
}
